import RejectionApproval from "./components/pages/manufacturing_app/transaction/RejectionApproval";
/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react'   
import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import ConstantsList from './common/Constants';

import Layout  from './components/layout/Layout';
import Page404 from './components/pages/404Page';
import Login from './components/pages/login/Login';
import Register from './components/pages/login/Register';
import Company from './components/pages/manufacturing_app/settings/Company';
import Profile from './components/pages/manufacturing_app/settings/Profile';

// --------------------------------------  manufacturing_app Starts
import HOME from './components/pages/manufacturing_app';
import DASHBOARD from './components/pages/manufacturing_app/Dashboard/Dashboard';
import MachineUtilizationDashboard from './components/pages/manufacturing_app/Dashboard/MachineUtilizationDashboard/MachineUtilizationDashboard';
import OperatorUtilizationDashboard from './components/pages/manufacturing_app/Dashboard/operator-utilization/OperatorUtilizationDashboard';

import OVERVIEW from './components/pages/manufacturing_app/Overview';
import OVERVIEWMACHINES from './components/pages/manufacturing_app/OverviewMachines';

import Departments from './components/pages/manufacturing_app/master/Departments';
import Machines from './components/pages/manufacturing_app/master/Machines';
import Customers from './components/pages/manufacturing_app/master/Customers';
import Checklist from './components/pages/manufacturing_app/master/Checklist';
import Users from './components/pages/manufacturing_app/master/User';
import Size from './components/pages/manufacturing_app/master/Size';
import JobStatus from './components/pages/manufacturing_app/master/JobStatus';
import Reason from './components/pages/manufacturing_app/master/Reason';
import Consumable from './components/pages/manufacturing_app/master/Consumable';
import StoreOperations from './components/pages/manufacturing_app/StoreOperations';
import RevisingNumber from './components/pages/manufacturing_app/master/RevisingNumber';
// --------------------------Transactions---------------------------------------

import GenerateJobCard from './components/pages/manufacturing_app/transaction/GenerateJobCard';
import MachineStatus from './components/pages/manufacturing_app/transaction/MachineStatus';
import OperatorChecklist from './components/pages/manufacturing_app/transaction/OperatorChecklist';
import AcknowledgeJobCard from './components/pages/manufacturing_app/transaction/AcknowledgeJobCard';
import StartStopJobCard from './components/pages/manufacturing_app/transaction/StartStopJobCard';
import OrderConfirmation from './components/pages/manufacturing_app/transaction/OrderConfirmation';
import ClosecurrentJobCard from './components/pages/manufacturing_app/transaction/ClosecurrentJobCard';
import ReworkJobCard from './components/pages/manufacturing_app/transaction/ReworkJobCard'
// --------------------------Reports---------------------------------------

import MachineIdleStatusReports from './components/pages/manufacturing_app/reports/MachineIdleStatusReports'
import OperatorCheckListReports from './components/pages/manufacturing_app/reports/OperatorChecklistReports'
import JobcardAnalyticsReports from './components/pages/manufacturing_app/reports/JobcardAnalyticsReports'
import ProductionStatusReports from './components/pages/manufacturing_app/reports/ProductionStatusReports'
import JobcardStatusReports from './components/pages/manufacturing_app/reports/JobcardStatusReports'
import OperatorsReports from './components/pages/manufacturing_app/reports/OperatorsReports'
import OperatorsEfficiency from './components/pages/manufacturing_app/reports/OperatorsEfficiency'
import OeeDashboard from './components/pages/manufacturing_app/reports/OeeDashboard/OeeDashboard'
import ChemicalBatchReports from './components/pages/manufacturing_app/reports/ChemicalBatchReports'
import BulkConsumpstionReports from './components/pages/manufacturing_app/reports/BulkConsumpstionReports';
import GeneralReports from './components/pages/manufacturing_app/reports/GeneralReports'
import SummaryReport from './components/pages/manufacturing_app/reports/SummaryReport'
import QualityCertificate from './components/pages/manufacturing_app/reports/QualityCertificate'
import ReworkReport from './components/pages/manufacturing_app/reports/ReworkReport'
import DeptAckStatusReports from './components/pages/manufacturing_app/reports/DeptAckStatusReports';
import ConsumptionQuantityReports from './components/pages/manufacturing_app/reports/ConsumptionQuantityReports';
import DeviceConfigPage from './components/pages/manufacturing_app/deviceConfig/DeviceConfigPage';
import ProfilePage from './components/pages/manufacturing_app/ProfilePage/ProfilePage';
import MenuConfiguration from './components/pages/manufacturing_app/settings/MenuConfiguration';
import AdminCategoryRoute from './components/pages/manufacturing_app/settings/AdminCategoryRoute';

// --------------------------------------  manufacturing_app Ends

//Redux
import { useDispatch, useSelector } from "react-redux";
import { getLoginUserData, updateDeviceId} from './redux/feature/userSlice';
import { getMenuOnUserRole } from './redux/feature/manufacturing_app/menuSlice';
import { getAllCustomerMasterDropdown, getAllDepartmentMasterDropdown, getAllMachineMasterDropdown, getAllSizeMasterDropdown, getConstantVariable, getPlanTypeList } from './redux/feature/manufacturing_app/commonSlice';
import { getDeviceId } from './common/deviceId';


// Assume this is your authentication check function
const isAuthenticated = () => {
    // Check if the token is present or valid
    const token = localStorage.getItem('token');
    return !!token;
  };

const PrivateRoute = ({ children }) => {
    console.log(">> RouterNav >> user isAuthenticated >> " , isAuthenticated());
    return isAuthenticated() ? children : <Navigate to="/Login" />;
};

const hasAdminRole = (user) => {
    const roles = Array.isArray(user?.roles) ? user.roles : [];
    return String(user?.category || '').toUpperCase() === ConstantsList.MASTER.USERS.ADMIN ||
        roles.some((role) => String(role?.roleId || '').toUpperCase() === ConstantsList.MASTER.USERS.ADMIN);
};

const AdminRoute = ({ children }) => {
    const currentUser = useSelector((state) => state?.user?.data);
    let storedUser = {};
    try {
        storedUser = JSON.parse(localStorage.getItem('userData') || '{}')?.data || {};
    } catch (error) {
        storedUser = {};
    }
    const user = currentUser?.userId ? currentUser : storedUser;

    if (!isAuthenticated()) return <Navigate to={ConstantsList.LOGIN} replace />;
    return hasAdminRole(user)
        ? children
        : <Navigate to={ConstantsList.DASHBOARD} replace />;
};

function RouterNav() {
    const { t, i18n } = useTranslation();

    // console.log(">> RouterNav >> ");
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchDeviceId = async () => {
            const id = await getDeviceId();
            console.log(">> deviceId", id);     
            dispatch(updateDeviceId(id))   
        };
        fetchDeviceId();
      
        changeLanguage("en"); // kannada, tamil, en, ae
        console.log(">> lang:", t('msg_name'));


        let localData = localStorage.getItem('userData');
        let userData={}
        if(localData){
            userData = JSON.parse(localData);

            // USER & MENU                
            dispatch(getConstantVariable());    // userSlice store
            dispatch(getMenuOnUserRole());    // userSlice store
            dispatch(getLoginUserData());    // userSlice store      
            dispatch(getAllSizeMasterDropdown());    // Common store  
            dispatch(getAllDepartmentMasterDropdown());    // Common store  
            dispatch(getAllMachineMasterDropdown());    // Common store
            // dispatch(getAllUserMasterDropdown());    // Common store            
            dispatch(getAllCustomerMasterDropdown());    // Common store  
            dispatch(getPlanTypeList());    // Common store  
        }  
        
    // eslint-disable-next-line          
    },[]);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
     };
    
     let userQCAccessData = useSelector((state) => state?.user?.data?.qcAccessReq); // User Details from Store

    return(
        <>  
            {/* <Page404/> */}
            <Routes>    
                {/* Public route */}
                <Route exact path='*' element={<Page404 />}></Route>
                <Route exact path='/' element={<Login />}></Route>
                <Route exact path={ConstantsList.LOGIN} element={<Login/>}></Route>                
                <Route exact path={ConstantsList.REGISTER} element={<Register/>}></Route>   
                <Route path='/' element={<Layout />}>
                    <Route path="/approval" element={<PrivateRoute><RejectionApproval key="approval" /></PrivateRoute>} />
                    <Route path="/approval-report" element={<PrivateRoute><RejectionApproval key="approval-report" report /></PrivateRoute>} />
                    <Route path={ConstantsList.MENU_CONFIGURATION} element={<AdminCategoryRoute><MenuConfiguration /></AdminCategoryRoute>} />
                    <Route  exact path={ConstantsList.PROFILE}  element={  <PrivateRoute><ProfilePage/></PrivateRoute>  } />  
                    <Route  exact path={ConstantsList.CONFIG}  element={  <PrivateRoute><DeviceConfigPage/></PrivateRoute>  } />  
                    <Route  exact path={ConstantsList.HOME}  element={  <HOME/>    } />

                    <Route  exact path={ConstantsList.DASHBOARD}  element={ <PrivateRoute> <DASHBOARD/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.MACHINE_UTILIZATION_DASHBOARD}  element={ <PrivateRoute> <MachineUtilizationDashboard/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.OPERATOR_UTILIZATION_DASHBOARD}  element={ <PrivateRoute> <OperatorUtilizationDashboard/>  </PrivateRoute>  } />

                    <Route  exact path={ConstantsList.OVERVIEW}  element={ <PrivateRoute> <OVERVIEW/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.OVERVIEWMACHINES}  element={ <PrivateRoute> <OVERVIEWMACHINES/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.DEPARTMENTS}  element={ <PrivateRoute> <Departments/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.MACHINES}  element={ <PrivateRoute> <Machines/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.CUSTOMERS}  element={ <PrivateRoute> <Customers/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.CHECKLIST}  element={ <PrivateRoute> <Checklist/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.USERS}  element={ <PrivateRoute> <Users/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.SIZE}  element={ <PrivateRoute> <Size/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.JOBSTATUS}  element={ <PrivateRoute> <JobStatus/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.REASON}  element={ <PrivateRoute> <Reason/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.REVISING_NUMBER}  element={ <AdminRoute> <RevisingNumber/> </AdminRoute> } />
                    <Route  exact path={ConstantsList.CONSUMPTION}  element={ <PrivateRoute> <Consumable/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.CHEMICAL}  element={ <PrivateRoute> <StoreOperations/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.GENERATEJOBCARD}  element={ <PrivateRoute> <GenerateJobCard/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.MACHINESTATUS}  element={ <PrivateRoute> <MachineStatus/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.OPERATORCHECKLIST}  element={ <PrivateRoute> <OperatorChecklist/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.ACKNOWLEDGEJOBCARD}  element={ <PrivateRoute> <AcknowledgeJobCard/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.STARTSTOPJOBCARD}  element={ <PrivateRoute> <StartStopJobCard/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.MACHINEIDLESTATUSREPORTS}  element={ <PrivateRoute> <MachineIdleStatusReports/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.OPERATORCHECKLISTREPORTS}  element={ <PrivateRoute> <OperatorCheckListReports/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.JOBCARDANALYTICS}  element={ <PrivateRoute> <JobcardAnalyticsReports/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.ORDERCONFIRMATION}  element={ <PrivateRoute> <OrderConfirmation/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.CLOSECURRENTJOBCARD}  element={ <PrivateRoute> <ClosecurrentJobCard/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.PRODUCTIONSTATUSREPORTS}  element={ <PrivateRoute> <ProductionStatusReports/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.JOBCARDSTATUSREPORTS}  element={ <PrivateRoute> <JobcardStatusReports/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.OEEDASHBOARD}  element={ <PrivateRoute> <OeeDashboard/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.OPERATORREPORTS}  element={ <PrivateRoute> <OperatorsReports/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.OPERATOREFFICIENCY}  element={ <PrivateRoute> <OperatorsEfficiency/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.REWORKJOBCARD}  element={ <PrivateRoute> <ReworkJobCard/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.CHEMICALBATCHREPORTS}  element={ <PrivateRoute> <ChemicalBatchReports/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.BULKCONSUMPTIONREPORTS}  element={ <PrivateRoute> <BulkConsumpstionReports/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.GENERALREPORTS}  element={ <PrivateRoute> <GeneralReports/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.SUMMARYREPORT}  element={ <PrivateRoute> <SummaryReport/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.REWORKREPORTS}  element={ <PrivateRoute> <ReworkReport/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.STORE} element={ <PrivateRoute> <StoreOperations/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.DEPTACKSTATUSREPORTS}  element={ <PrivateRoute> <DeptAckStatusReports/>  </PrivateRoute>  } />
                    <Route  exact path={ConstantsList.CONSUMPTIONQTYREPORT}  element={ <PrivateRoute> <ConsumptionQuantityReports/>  </PrivateRoute>  } />
                    {
                      userQCAccessData && <Route  exact path={ConstantsList.QUALITYCERTIFICATE}  element={ <PrivateRoute> <QualityCertificate/>  </PrivateRoute>  } />
                    }
                </Route>
            </Routes>  
            {/* <Footer/> */}
        </>
    );
}


export default RouterNav;
